/**
 * These are all theme variables, that can be used to style the application via the ThemeVariablesManager class.
 *
 * @export
 * @enum {number}
 */
export enum ThemeVariables {

    // ------------------- General ------------------
    buttonBorderRadius = 'button-border-radius',

    // ------------------- Toolbars -----------------
    toolbarColor = 'toolbar-color',

    // ----------------- Navigation -----------------
    navigationPanelIconMaxHeight = 'navigation-panel-icon-max-height',

    navigationHeaderBackgroundColor = 'navigation-header-background-color',
    navigationHeaderColor = 'navigation-header-color',

    navigationBackgroundColor = 'navigation-background-color',
    navigationColor = 'navigation-color',
    navigationIconColor = 'navigation-icon-color',

    hover_navigationItemBackgroundColor = 'hover-navigation-item-background-color',
    hover_navigationItemColor = 'hover-navigation-item-color',
    hover_navigationItemIconColor = 'hover-navigation-item-icon-color',

    active_navigationItemBackgroundColor = 'active-navigation-item-background-color',
    active_navigationItemColor = 'active-navigation-item-color',
    active_navigationItemIconColor = 'active-navigation-item-icon-color',

    // ----------------- App Bar -----------------
    appBarBackgroundColor = 'app-bar-background-color',
    appBarColor = 'app-bar-color',

    // ----------------- Grid-Stack -----------------
    gridCellHeight = 'grid-cell-height',

    // -------------------- View --------------------
    viewPrimaryColor = 'view-primary-color',
    viewSecondaryColor = 'view-secondary-color'

}